var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useCallback, useEffect, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';


import { Icon } from "../../UI";
import { actions, Translate, t } from "./..";

import { NeedAuthorization } from "../../Auth";
import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";

const locationSearch = (location) => {
  const cleanSearch = location.search.split(/page=\d+|&page=\d+/).join('');
  return cleanSearch === '?' ? '' : cleanSearch;
};

const prepareValues = (
languageMap,
locale,
location) =>
{
  const languages = languageMap.toJS();

  const selectedLanguage =
  languages.find((lang) => lang.key === locale) || languages.find((lang) => lang.default);

  const urlLocation = location;

  const path = urlLocation.pathname.replace(new RegExp(`^/?${locale}/|^/?${locale}$`), '/');

  if (location.search.match(/page=/)) {
    urlLocation.search = locationSearch(location);
  }

  return { languages, selectedLanguage, urlLocation, path };
};

const mapStateToProps = (state) => ({
  languages: state.settings.collection.get('languages'),
  i18nmode: state.inlineEdit.get('inlineEdit'),
  locale: state.locale,
  user: state.user
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ toggleInlineEdit: actions.toggleInlineEdit }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);



const i18NMenuComponent = ({
  location,
  languages: languageMap,
  i18nmode,
  user,
  locale,
  toggleInlineEdit
}) => {
  if (!languageMap || languageMap.size < 1 || languageMap.size <= 1 && !user.get('_id')) {
    return /*#__PURE__*/_jsx("div", { className: "no-i18nmenu" });
  }

  const menuRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { languages, selectedLanguage, path, urlLocation } = prepareValues(
  languageMap,
  locale,
  location);


  useEffect(() => {
    if (locale !== (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.key)) {
      window.location.assign(path);
    }
  }, [languages.length]);

  useOnClickOutsideElement(
  menuRef,
  useCallback(() => {
    setDropdownOpen(false);
  }, []));


  return /*#__PURE__*/(
    React.createElement("div", {
      className: languageMap.size === 1 ? 'menuNav-I18NMenu one-language' : 'menuNav-I18NMenu',
      role: "navigation",
      "aria-label": "Languages",
      ref: menuRef },

    i18nmode && /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem",
      type: "button",
      onClick: toggleInlineEdit,
      "aria-label": t('System', 'Turn off inline translation', null, false) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "live-translate" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "circle", className: i18nmode ? 'live-on' : 'live-off' }))), /*#__PURE__*/


    _jsx("span", { className: "singleItem" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Live translate")))),





    !i18nmode && /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem dropdown",
      type: "button",
      onClick: () => setDropdownOpen(!dropdownOpen) }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.localized_label), "\xA0", /*#__PURE__*/

    _jsx(Icon, { icon: dropdownOpen ? 'caret-up' : 'caret-down' })), /*#__PURE__*/


    _jsx("ul", { className: dropdownOpen ? 'dropdown-menu expanded' : 'dropdown-menu' }, void 0,
    languages.map((language) => {
      const url = `/${language.key}${path}${
      path.match('document') ? '' : urlLocation.search
      }`;

      return /*#__PURE__*/(
        _jsx("li", {

          className: locale === language.key ? 'menuNav-item active' : 'menuNav-item' }, language._id, /*#__PURE__*/

        _jsx("a", { href: url }, void 0, language.localized_label || language.label)));


    }), /*#__PURE__*/

    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "live-translate",
      type: "button",
      onClick: () => {
        toggleInlineEdit();
        setDropdownOpen(false);
      } }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "circle", className: i18nmode ? 'live-on' : 'live-off' }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Live translate"))))))));








};

const container = withRouter(connector(i18NMenuComponent));

export { container as i18NMenuComponent };